const parseJson = (input, defaultValue) => {
  try {
    if (typeof input === 'undefined') return null;

    if (typeof input === null) return null;

    if (typeof input !== 'string') return defaultValue;

    const object = JSON.parse(input);

    if (object === null) return null;

    if (typeof object === 'string') return parseJson(object, defaultValue);

    return object;
  } catch (e) {
    console.warn('Error when parsing: ', defaultValue);
    console.warn(e);

    return defaultValue;
  }
};

export const getLocalStorageJson = (key, defaultValue = null) =>
  parseJson(localStorage.getItem(key), defaultValue);
export const setLocalStorageJson = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));

export const getSessionStorageJson = (key, defaultValue = null) =>
  parseJson(sessionStorage.getItem(key), defaultValue);
export const setSessionStorageJson = (key, value) =>
  sessionStorage.setItem(key, JSON.stringify(value));
